import { defineDeckPassive } from '../authoring/index.js';
const PARENT_EFFECT_VAR = 'armedStructuresParentEffectId';
function reconcileStructure(ctx, instanceId) {
    const parent = ctx.effect;
    if (parent?.scope.kind !== 'player')
        return;
    const unit = ctx.q.instance(instanceId);
    const shouldBuff = unit?.zone === 'board'
        && unit.controllerId === parent.scope.playerId
        && ctx.q.cardType(instanceId) === 'STRUCTURE';
    const matching = ctx.q.effectsOn({ kind: 'unit', instanceId })
        .filter((effect) => effect.defId === ArmedStructuresPassive.id
        && effect.vars[PARENT_EFFECT_VAR] === parent.id);
    if (!shouldBuff) {
        for (const effect of matching)
            ctx.ops.removeEffect(effect.id);
        return;
    }
    if (matching.length === 0) {
        ctx.ops.addEffect({
            defId: ArmedStructuresPassive.id,
            scope: { kind: 'unit', instanceId },
            vars: {
                [PARENT_EFFECT_VAR]: parent.id,
                attackPermission: 'allow_non_unit',
            },
            statMods: [{ stat: 'attack', op: 'add', value: 2 }],
        });
        return;
    }
    for (const duplicate of matching.slice(1))
        ctx.ops.removeEffect(duplicate.id);
}
function affectedInstanceId(event) {
    switch (event.type) {
        case 'UnitEnteredPlay':
        case 'CardTransformed':
        case 'CaptureApplied':
        case 'CaptureReturned':
            return event.instanceId;
        default:
            return undefined;
    }
}
export const ArmedStructuresPassive = defineDeckPassive({
    id: 'armed_structures',
    role: 'available',
    presentation: {
        name: 'Вооружённые постройки',
        description: 'Все ваши Структуры получают +2 к атаке.',
        glyph: {
            colors: ['#10213A', '#524734', '#9B8567', '#807158', '#AA997A'],
            rows: [
                '......11.11.11......',
                '....112213212211....',
                '...13233232322341...',
                '...13353533353441...',
                '....111111111111....',
                '.....1222222221.....',
                '.....1333334441.....',
                '.....1525332231.....',
                '.....1325532241.....',
                '.....1353335541.....',
                '.....1333354341.....',
                '....111111111111....',
                '....133343443341....',
                '.....1222222221.....',
                '.....1333443341.....',
                '....133352254341....',
                '....133332244441....',
                '...14533322343441...',
                '...13344422444421...',
                '..1111111111111111..',
            ],
        },
    },
    hooks: {
        onAnyEvent(ctx, event) {
            if (ctx.effect?.scope.kind !== 'player')
                return;
            const instanceId = affectedInstanceId(event);
            if (instanceId !== undefined)
                reconcileStructure(ctx, instanceId);
        },
        onRoundStart(ctx) {
            if (ctx.effect?.scope.kind !== 'player')
                return;
            for (const unit of ctx.q.unitsOf(ctx.effect.scope.playerId)) {
                reconcileStructure(ctx, unit.id);
            }
        },
    },
});
//# sourceMappingURL=armed_structures.js.map